/** A plain text cell of the bulk-upload example table (`ExampleFileStructureTableConfig.tsx`). */
import { Flex } from "@ryerson/frontend.layout";
import { Typography } from "@ryerson/frontend.typography";
import React from "react";

interface ExampleFileStructureTableBasicCellProps {
	itemData?: string | number | object | boolean;
}

/** Renders the cell value as small text. */
const ExampleFileStructureTableBasicCell: React.FC<ExampleFileStructureTableBasicCellProps> = ({
	itemData,
}) => {
	return (
		<Flex wrap="wrap" css={{ padding: 5 }}>
			<Typography size="sm">{itemData}</Typography>
		</Flex>
	);
};

export default ExampleFileStructureTableBasicCell;
